import reCheckboxGroup from "../checkbox/src/checkbox-group.vue";

reCheckboxGroup.install = function (Vue) {
  Vue.component(reCheckboxGroup.name, reCheckboxGroup);
};

export default reCheckboxGroup;
